<template lang="pug">
  vm-prompt(@vm-cancel="close" @vm-accept="setAction" @vm-close="close" :vm-accept-text="$t('strings.accept')" :vm-cancel-text="$t('strings.cancel')" :vm-is-valid="!$v.form.$invalid " :vm-active="isModalLossVisible" :vm-title='title')
    vm-row(vm-align="center" vm-type="flex" vm-justify="space-between" vm-w="12")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-select(url="loss-reasons" :placeholder='$t("quotations.loss_reason_id_placeholder")' v-model="form.loss_reason_id" :label='$t("quotations.loss_reason_id")')
            vm-select-item(:key="index" :value="item.id" :text="item.name" v-for="(item,index) in quotationsCatalog.lossReasons")
      vm-col(vm-justify="center", vm-align="center", vm-w=12)
        b-form-group
          vm-input(:placeholder='$t("quotations.loss_description_placeholder")' v-model="form.loss_description"  :label='$t("quotations.loss_description")')
</template>

<script>
import { required } from 'vuelidate/lib/validators'
import { createNamespacedHelpers } from 'vuex'
const { mapGetters, mapActions } = createNamespacedHelpers('Quotations')

export default {
  name: 'ModalQuotationsLoss',
  props: {
    form: {
      default: () => [],
      type: Object
    },
    title: {
      type: String,
      default: 'Cotizacion perdida'
    },
    id: {
      type: Number,
      default: () => ''
    }
  },
  validations: {
    form: {
      loss_reason_id: {
        required
      },
      loss_description: {
        required
      }
    }
  },
  computed: {
    ...mapGetters([
      'quotationsCatalog',
      'isModalLossVisible'
    ])
  },
  methods: {
    ...mapActions([
      'lossQuotation',
      'setModalLossVisible'
    ]),
    async setAction () {
      await this.lossQuotation({ id: this.id, form: this.form })
    },
    close () {
      this.setModalLossVisible(false)
    }
  }
}
</script>

<style>
.vm-select--options {
  z-index: 400331 !important;
}
a {
  cursor: pointer;
}
</style>
